<div #container
     class="container bg2 page-keyword2">

  <app-header [keyHistory]="HISTORY_KEY_SEARCH_VIDEO"
              placeholder="동영상을 검색 합니다."
              canGoHistory="true"
              (goHistory)="onGoHistory()"
              (search)="SearchVideo($event)"></app-header>

  <app-left-menu></app-left-menu>


  <section class="video-screen-list">

    <div class="inner wrap">

      <div class="screen-list-group">

        <div *ngIf="selectedStory === null"
             @expandCollapse
             class="screen-box screen2">
          <div class="tit-box">지역별 이야기</div>

          <div class="label-select-list">
            <div *ngFor="let cityInfo of CITY2_INFO_LIST"
                 class="label-select-box type-{{ cityInfo.css }}"
                 [class.on]="selectedCity === cityInfo.city2">
              <div class="label"
                   (click)="onChangeCity($event, cityInfo.city2)">
                <div class="txt-box"
                     [class.inactive]="isCityOff(cityInfo.city2)"
                     [innerHTML]="cityInfo.listTxt | citySize | resize">
                </div>
              </div>
            </div>
          </div>

        </div>

        <div *ngIf="selectedCity === null"
             @expandCollapse
             class="screen-box screen1">
          <div class="tit-box">이야기 모아 보기</div>

          <div class="story-item-list">
            <a *ngFor="let story of listStory"
             class="story-item-box"
             (click)="onSelectStory($event, story)">

              <div class="img-box">
                <img src="{{ makeImageUrl((!selectedStory || selectedStory === story.no) ? story.image : story.imageUnselected) }}"
                     alt="이미지">
              </div>
              <div class="info-box">{{ story.title }}</div>
          </a>
          </div>
        </div>

        <div class="screen-box">

          <div class="empty-box"
               *ngIf="isEmpty">
            <div class="img-box">
              <img src="assets/img/img_menu_tiger.svg">
            </div>
            <div class="keyword-no-result-box">
              영상이 존재하지 않습니다.
            </div>
          </div>

          <div class="reload-icon" *ngIf="isLoading">
            <img #reload src="assets/img/loading_icon.gif">
          </div>

          <div class="video-list">
            <app-video-box *ngFor="let video of listVideo"
                           class="video-item-box"
                           [video]="video"
                           [sendingBookmark]="sendingBookmark"
                           (toggleBookmark)="ToggleBookmark($event)"></app-video-box>
          </div>
        </div>

      </div>

    </div>
  </section>

  <app-footer [on]="FOOTER_ON.MOVIE_COLLECT"></app-footer>
</div>

<app-common-popups></app-common-popups>

